export { default as Series_ChooseRecommendation } from './choose-recommendation/indexS';
// export { default as Series_ImgBtnSwiper } from './img-btn-swiper/indexS';
export { default as Series_KSPSwiper } from './ksp-swiper/indexS';
export { default as Series_KVSwiper } from './kv-swiper/indexS';
// export { default as Series_Possibilities } from './possibilities/indexS';
export { default as Series_DiscoverMore } from './discover-more/indexS';
export { default as Series_ProductCategory } from './product-category/indexS';
export { default as Series_ProductCompare } from './product-compare/indexS';
export { default as Series_ProductCompares } from './product-compares/indexS';
export { default as Series_ProductFloor } from './product-floor/indexS';
export { default as Series_ProductFloors } from './product-floors/indexS';
// export { default as Series_ProductSeries } from './product-series/indexS';
export { default as Series_ProductSwiper } from './product-swiper/indexS';
export { default as Series_ServiceSupport } from './service-support/indexS';
